/**
 * Capitalize the input string.
 * example:
 * ```
 * capitalize('foo Bar baZ') // => 'Foo Bar baZ'
 * ```
 *
 * TODO: I18N
 * @param s
 */
export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

/**
 * Capitalize and append punctuation to the input string.
 * example:
 * ```
 * sentencify('foo Bar baZ', '!') // => 'Foo Bar baZ!'
 * ```
 *
 * TODO: I18N
 * @param s
 * @param punctuation
 */
export const sentencify = (s: string, punctuation: string = '.') => (
  s.endsWith(punctuation)
    ? capitalize(s)
    : capitalize(`${s}${punctuation}`)
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/word-helpers.ts